// Import Components
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Social from './components/Social';
import Footer from './components/Footer';
import Awards from "./components/Awards"
import Activity from "./components/Activity";

function App() {
	return (
		<div className="App">
			<Header />
			<About />
			<Projects />
			<Experience />
			<Awards />
			<Activity />
			<Social />
			<Footer />
		</div>
	);
}

export default App;
